import { UnexpectedApiResponseError } from 'src/Libs/errors'
import { ApiResult } from 'src/Libs/api'
import { AuthFetchWithResponse } from 'src/Types/api'
import { StatusCodes } from 'src/Libs/http-status-codes'
import { IdlePeriodLegacySettingsFormModel, IdlePeriodLegacySettingsModel } from 'src/Libs/smart-charge/models'
import { IdlePeriodsLegacySettingsDto, IdlePeriodsLegacySettingsUpdateDto } from 'src/Libs/smart-charge/dto'
import { fromLegacyIdlePeriodDtoToModel, fromLegacyIdlePeriodSettingsFormToUpdateDto } from 'src/Libs/smart-charge/transformers'

/**
 * Returns the legacy idle period settings for a storage reference
 * @param serialNumber
 * @param authFetch
 */
export const getSettings = async (
  serialNumber: string,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<IdlePeriodLegacySettingsModel, boolean>> => {
  try {
    const response = await authFetch<IdlePeriodsLegacySettingsDto>({
      path: `storages/${serialNumber}/smart-functions/smart-charge/idle-periods/legacy`,
      method: 'GET',
    })

    if (response.status === StatusCodes.OK) {
      const model = fromLegacyIdlePeriodDtoToModel(response.data as IdlePeriodsLegacySettingsDto)
      return new ApiResult<IdlePeriodLegacySettingsModel, boolean>(model)
    }

    return new ApiResult<IdlePeriodLegacySettingsModel, boolean>(null, true)
  } catch (error) {
    return new ApiResult<IdlePeriodLegacySettingsModel, boolean>(null, true)
  }
}

/**
 * Update the legacy Idle Period configuration to a single connected storage device.
 *
 * @param serialNumber
 * @param model
 * @param authFetch
 */
export const updateSettings = async (
  serialNumber: string,
  model: IdlePeriodLegacySettingsFormModel,
  authFetch: AuthFetchWithResponse
): Promise<IdlePeriodsLegacySettingsUpdateDto> => {
  const payload = fromLegacyIdlePeriodSettingsFormToUpdateDto(model)

  const response = await authFetch<void>({
    path: `storages/${serialNumber}/smart-functions/smart-charge/idle-periods/legacy`,
    method: 'PUT',
    payload: JSON.stringify(payload),
  })
  if (response.status !== StatusCodes.NO_CONTENT) {
    throw new UnexpectedApiResponseError(response.status)
  }

  return payload
}
